import React, { useState, useEffect } from "react";
import Sidebar from "../../components/SideBar/sidebar";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, Button } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { Image } from "antd";
import ProcessDone from "../../components/Orders/ProcessDone";
import CancelOrder from "../../modals/cancelorder";
import {
  acceptOrder,
  DeliverOrder,
  GetBillDetails,
  getdata,
  LahloobprocessOrder,
  LahloobupdateOrder,
  orderHandover,
  processOrder,
  quantityUpdate,
  sendReplacementLogAPI,
  updateOrder,
  updateorderStage,
} from "../../API  Functions/OrderlistFunction";
import OrdercustomerDetails from "../../components/Orders/OrdercustomerDetails";
import {
  htmlContent,
  getdatahtml,
} from "../../components/orderlist/printorderlist";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import Cancelledpopup from "../../modals/Cancelledpopup";
import PaymentInfo from "../../components/Orders/PaymentInfo";
import Orderdeliveredpopup from "../../modals/Orderdeliveredpopup";
import deleteicon from "../../assets/Order/Delete.svg";
import { searchdeliverypartner } from "../../API  Functions/DeliveryPartnerFunctions";
import DeliveryBoyDetails from "../../modals/DeliveryBoyDetails";
import AssignDeliveryBoypopup from "../../modals/AssignDeliveryBoypopup";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import weight_icon from "../../assets/Order/weight_icon.svg";
import ReturnCancelOrder from "../../modals/ReturnCancelOrder";
import SuccessModal from "../../modals/Sucessmodal";
import CompleteSuccess from "../../modals/CompleteSuccess";
import LoadingSpinner from "../../components/Loading";
import ReplaceItemModal from "../../components/ReplaceItemModal";
import { checkPermission } from "../../Utils/permissionHelper";

const Orderlist = () => {
  const { t, i18n } = useTranslation();
  const store_data = useSelector((state) => state.login?.user);
  // console.log("store_data", store_data);
  // const user_id = useSelector((state) => state.login?.user?.user_id);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob
  );
  const userData = useSelector((state) => state?.login?.user?.result);

  const [showComponent, setShowComponent] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [isCancelOrderOpen, setCancelOrderOpen] = useState(false);
  const [isReturnCancelOrderOpen, setReturnCancelOrderOpen] = useState(false);
  const [Quantity, setQuantity] = useState(0);
  const [Error, setError] = useState(false);
  const [processButton, setprocessbutton] = useState(false);
  const [acceptbutton, setacceptbutton] = useState(false);
  const [loading, setloading] = useState(false);
  const [cancelledpopup, setcancelledpopup] = useState(false);
  const [deliveredpopup, setdeliveredpopup] = useState(false);
  const [zero, setzero] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [DeliveryPartners, setDeliveryPartners] = useState([]);
  const [popup, setpopup] = useState(false);
  const [searchid, setsearchid] = useState(localStorage.getItem("searchid"));
  const [draftquantites, setdraftquantities] = useState([]);
  const location = useLocation();
  const [orderDetail, setorderDetail] = useState({});
  const [data, setdata] = useState(orderDetail || {});
  const [billDetails, setBillDetails] = useState(null);
  const [ProdLoading, setProdLoading] = useState(true);
  const [canProcessOrder, setCanProcessOrder] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [SuccessPopup, setSuccessPopup] = useState(false);
  const [itemToReplace, setItemToReplace] = useState({});
  const [replaceItemModal, setOpenReplaceItemModal] = useState(false);
  const [replaceRelatedItems, setReplaceRelatedItems] = useState({
    replacedItems: [],
    replacingItems: [],
  });
  const { from } = location.state || {};

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("orderDetail"))
      localStorage?.setItem("searchid", params.get("orderDetail"));
    const searchparam =
      params.get("orderDetail") || localStorage.getItem("searchid");
    setsearchid(searchparam);
    if (searchparam) {
      calldata(searchparam);
      setloading(true);
    }
  }, []);

  const calldata = (searchid) => {
    getdata(user_id, searchid, "", 1, 0).then((datagot) => {
      setloading(false);
      setdata(datagot);
      setorderDetail(datagot);
    });
  };

  useEffect(() => {
    if (
      orderDetail &&
      orderDetail.order_details &&
      orderDetail.order_details.order_id
    ) {
      const fetchBillDetails = async () => {
        try {
          const response = await GetBillDetails(
            orderDetail.order_details.order_id
          );

          setBillDetails(response?.data?.result[0]?.response);
        } catch (error) {
          console.error("Error fetching bill details:", error);
        }
      };

      fetchBillDetails();
    }
  }, [orderDetail]);

  const handleOpenCancelOrder = () => {
    setCancelOrderOpen(true);
  };

  const handleCloseCancelOrder = () => {
    setCancelOrderOpen(false);
  };
  const [orderedItems, setOrderedItems] = useState([]);

  useEffect(() => {
    const orderedItems =
      data?.existing_items?.filter((item) => item.product_uom_qty > 0) ?? [];
    {
      (data?.order_details?.order_status === "Order Pending" ||
        data?.order_details?.order_status === "In Processing") &&
        setOrderedItems(orderedItems);
      console.log("orderedItems", orderedItems);
    }
  }, [data]);

  useEffect(() => {
    if (data && data.existing_items) {
      const allItems = [
        ...data.existing_items,
        // ...(replaceRelatedItems?.replacingItems || []),
      ];

      const initialQuantities = allItems.map((item) => ({
        product_id: item.product_id,
        sell_price: item.price_unit,
        value: item.product_uom_qty,
      }));

      setdraftquantities(initialQuantities);
      setProdLoading(false);
    }
  }, [data]);

  const handleQuantityChange = (
    newQuantity,
    index,
    order_id,
    id,
    product_id
  ) => {
    setzero(true);

    if (newQuantity < 0) {
      newQuantity = 0;
    }
    const allItems = [
      ...data.existing_items,
      ...(replaceRelatedItems?.replacingItems || []),
    ];
    const product = allItems.find((item) => item.product_id === product_id);
    const product2 = data.existing_items.find(
      (item) => item.product_id === product_id
    );
    const available_qty = product2?.product_uom_qty;
    const sell_price = product?.price_unit;

    if (newQuantity > available_qty) {
      newQuantity = available_qty;
    }

    setdraftquantities((draftquantities) => {
      const existingIndex = draftquantities.findIndex(
        (item) => item.product_id === product_id
      );

      if (existingIndex !== -1) {
        return draftquantities.map((item, idx) =>
          idx === existingIndex
            ? {
              product_id: product_id,
              sell_price: sell_price,
              value: newQuantity,
            }
            : item
        );
      } else {
        if (newQuantity > 0) {
          return [
            ...draftquantities,
            {
              product_id: product_id,
              sell_price: sell_price,
              value: newQuantity,
            },
          ];
        }
        return draftquantities;
      }
    });
  };

  const handlePrintOrderList = () => {
    // console.log("RECIEPT DATA------>", data);

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(getdatahtml(data, is_lahloob, t, i18n, userData));
    doc.close();

    iframe.contentWindow.focus();
    // iframe.contentWindow.print();

    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 1000);
  };

  const handleAssignForDelivery = async () => {
    setIsModalVisible(true);
  };

  const handleHandover = async (order_id) => {
    try {
      const payload = {
        order_id: order_id,
      };

      const response = await orderHandover(payload);

      //   console.log("API Response:", response);
      if (response?.data?.result?.status === "success") {
        setSuccessPopup(true);
        setPopupMessage("Order Handedover Successfully");
        // popup();
      }
    } catch (error) {
      console.error("Error confirming return order:", error);
    }
  };

  useEffect(() => {
    const allZeroQuantities = draftquantites.every((item) => item.value === 0);
    setCanProcessOrder(!allZeroQuantities);
  }, [draftquantites]);

  // console.log("filteredNewItems===>", filteredNewItems);

  const processOrderActions = async (orderId) => {
    // Make sure orderId is valid before proceeding
    if (!orderId) {
      setloading(false);
      console.error("Invalid order ID");
      return;
    }

    const product_lines =
      replaceRelatedItems?.replacingItems?.map((item) => {
        const matchingDraft = draftquantites?.find(
          (dq) => dq.product_id === item.product_id
        );

        return {
          old_product_id: item.replaced_item_id,
          new_product_id: item.product_id,
          old_qty: item.replaced_item_qty,
          new_qty:
            matchingDraft?.value === undefined
              ? item.product_uom_qty
              : matchingDraft.value,
        };
      }) || [];

    if (product_lines.length > 0) {
      try {
        const payload = {
          order_id: orderId,
          product_lines,
        };

        const replaceRes = await sendReplacementLogAPI(payload); // <== Replace with your actual API function

        if (replaceRes?.result?.status_code !== 200) {
          setloading(false);
          console.error("Replacement log API failed", replaceRes);
          return;
        }
        setReplaceRelatedItems({
          replacedItems: [],
          replacingItems: [],
        });
      } catch (error) {
        setloading(false);
        console.error("Error calling replacement log API", error);
        return;
      }
    }

    if (is_lahloob) {
      // Construct the payload for LAHLOOB_UPDATE_PICKER_ORDER
      const pickerPayload = {
        order_id: orderId,
        picker_name: JSON.stringify(user_id),
        lines: [
          // Step 1: Draft quantities with optional `is_replaced_item`
          ...draftquantites.map((item) => {
            const isReplaced = replaceRelatedItems?.replacedItems?.some(
              (replaced) => replaced.product_id === item.product_id
            );
            const isReplacing = replaceRelatedItems?.replacingItems?.some(
              (replaced) => replaced.product_id === item.product_id
            );
            return {
              product_id: item.product_id,
              pick_qty: isReplaced
                ? 0
                : item.value === undefined
                  ? item.product_uom_qty
                  : item.value,
              ...(isReplaced ? { is_replaced_item: true } : {}),
              ...(isReplacing ? { is_replaced_by: true } : {}),
            };
          }),
        ],
      };

      // Call the LAHLOOB_UPDATE_PICKER_ORDER API
      LahloobupdateOrder(pickerPayload)
        .then((response) => {
          console.log("LAHLOOB_UPDATE_PICKER_ORDER", response);

          if (response?.status_code === 200) {
            const preparedPayload = {
              order_id: orderId,
            };

            // Call the LAHLOOB_ORDER_PREPARED API
            LahloobprocessOrder(preparedPayload)
              .then((response) => {
                // console.log("LAHLOOB_ORDER_PREPARED", response);

                if (response?.status_code === 200) {
                  calldata(searchid);
                  setloading(false); // Stop loading indicator
                } else {
                  setloading(false); // Stop loading even if LAHLOOB_ORDER_PREPARED fails
                  console.error("Failed to prepare Lahloob order", response);
                }
              })
              .catch((error) => {
                setloading(false); // Stop loading if LAHLOOB_ORDER_PREPARED fails
                console.error("Error during LAHLOOB_ORDER_PREPARED:", error);
              });
          } else {
            setloading(false); // Stop loading if LAHLOOB_UPDATE_PICKER_ORDER fails
            console.error("Failed to update Lahloob picker order", response);
          }
        })
        .catch((error) => {
          setloading(false); // Stop loading if LAHLOOB_UPDATE_PICKER_ORDER fails
          console.error("Error during LAHLOOB_UPDATE_PICKER_ORDER:", error);
        });
    } else {
      // If not Lahloob, proceed with the regular order update and processing
      //    const filteredNewItems = draftquantites
      // .filter((item) => item.value > 0)
      // .map((item) => ({
      //   product_id: item.product_id,
      //   price_unit: item.sell_price,
      //   quantity: item.value === undefined ? item.product_uom_qty : item.value,
      // }));
      const filteredNewItems = [
        // Step 1: Map over draftquantites
        ...draftquantites
          // .filter((item) => item.value > 0)
          .map((item) => {
            const isReplaced = replaceRelatedItems?.replacedItems?.some(
              (replaced) => replaced.product_id === item.product_id
            );
            const isReplacing = replaceRelatedItems?.replacingItems?.some(
              (replaced) => replaced.product_id === item.product_id
            );
            return {
              product_id: item.product_id,
              price_unit:
                typeof item.sell_price === "number"
                  ? item.sell_price.toFixed(2)
                  : item.sell_price,
              quantity: isReplaced
                ? 0
                : item.value === undefined
                  ? item.product_uom_qty
                  : item.value,
              ...(isReplaced ? { is_replaced_item: true } : {}),
              ...(isReplacing ? { is_replaced_by: true } : {}),
            };
          }),
      ];
      console.log("filteredNewItems===>", filteredNewItems);

      updateOrder(user_id, orderId, [], filteredNewItems)
        .then((response) => {
          if (response?.status_code === 200) {
            // If updateOrder is successful, proceed with processing the order
            processOrder(user_id, orderId)
              .then((response) => {
                if (response?.status_code === 200) {
                  // If both API calls succeed, trigger callback function
                  calldata(searchid);
                  setloading(false); // Stop loading indicator
                } else {
                  setloading(false); // Stop loading even if processOrder fails
                  console.error("Failed to process order", response);
                }
              })
              .catch((error) => {
                setloading(false); // Stop loading if processOrder fails
                console.error("Error during processOrder:", error);
              });
          } else {
            setloading(false); // Stop loading if updateOrder fails
            console.error("Failed to update order", response);
          }
        })
        .catch((error) => {
          setloading(false); // Stop loading if updateOrder fails
          console.error("Error during updateOrder:", error);
        });
    }
  };

  const handleReturnCancelOrder = () => {
    console.log("handleReturnCancelOrder");

    setReturnCancelOrderOpen(true);
    console.log("setReturnCancelOrderOpen", isReturnCancelOrderOpen);
  };

  const newItem = {
    quant_id: 14577,
    product_image_url: "https://assets.myginne.com/assets/14577-01.webp",
    product_name: "7up Hadaba Glass Bottle (300 ml)",
    barcode: "476547676878",
    machine_barcode: false,
    uom: "Units",
    current_price: 100.0,
    current_cost_price: 98.0,
    prod_discount: 0.0,
    discounted_price: 100.0,
    system_quantity: 40.0,
    categ_id: 39,
    categ_name: "Drinks",
    sub_categ_id: 142,
    sub_categ_name: "Soft Drinks",
    last_updated: "2025-04-16 09:08:39",
  };

  const openReplaceWindow = (item) => {
    HandleReplaceItem(newItem, item);
  };

  const HandleReplaceItem = (item, oldProd) => {
    console.log("item =>", item);
    console.log("oldProd =>", oldProd);

    // Clear selection and close modal
    setItemToReplace({});
    setOpenReplaceItemModal(false);

    // Prepare the replacing item object
    const replacingItem = {
      company_name: oldProd?.company_name,
      discounted_price_unit: item?.discounted_price,
      floor_no: oldProd?.floor_no,
      image: item?.product_image_url,
      line_no: oldProd?.line_no,
      pick_qty: oldProd?.pick_qty,
      price_total: item?.current_price * oldProd?.product_uom_qty,
      price_unit: item?.current_price,
      product_barcode: item?.barcode,
      product_id: item?.quant_id,
      product_name: item?.product_name,
      product_pack: oldProd?.product_pack,
      product_uom: item?.uom,
      product_uom_qty: oldProd?.product_uom_qty,
      rack: oldProd?.rack,
      shelf: oldProd?.shelf,
      replacing_item: true,
      replaced_item_id: oldProd?.product_id,
      replaced_item_qty: oldProd?.product_uom_qty,
    };

    // Update replaced and replacing items
    setReplaceRelatedItems((prev) => ({
      replacedItems: [...prev.replacedItems, { ...oldProd, replaced_item: true }],
      replacingItems: [...prev.replacingItems, replacingItem],
    }));

    // Combine all items (existing + replacing + current replacing)
    const allItems = [
      ...draftquantites,
      replacingItem,
    ];

    // Generate draft quantities
    const initialQuantities = allItems.map((item) => ({
      product_id: item.product_id,
      sell_price: item.sell_price || item.price_unit,
      value: item.value == undefined ? item.product_uom_qty : item.value,
    }));

    setdraftquantities(initialQuantities);
  };


  const DeleteReplacingItem = (item) => {
    setReplaceRelatedItems((prev) => ({
      replacedItems: prev.replacedItems.filter(
        (prod) => prod.product_id !== item.replaced_item_id
      ),
      replacingItems: prev.replacingItems.filter(
        (prod) => prod.product_id !== item.product_id
      ),
    }));
    setdraftquantities((prev) =>
      prev.filter((prod) => prod.product_id !== item.product_id)
    );
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        {/* <div className="md:h-[8vh] flex mb-8"> */}
        <Navbar heading="eorders" />
        {/* </div> */}
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
          {loading ? (
            <ShimmerLoader />
          ) : (
            <>
              <div className="font-extrabold">
                {/* <Breadcrumb
                  separator={<DoubleRightOutlined />}
                  items={[
                    // {
                    //   title: t("all_orders"),
                    //   href: "/orders",
                    // },
                    {
                      title: (
                        <Link to={routes.orders}> {t("all_orders")} </Link>
                      ),
                      key: "all_orders", // Unique key for this breadcrumb
                    },
                    {
                      title: `${orderDetail?.order_details?.order_no}`,
                    },
                  ]}
                /> */}
                <div className="mt-4">
                  <Breadcrumb
                    separator={<DoubleRightOutlined />}
                    items={[
                      {
                        title:
                          from === "cashback" ? (
                            <Link to={routes.cashback}>{t("Cashback")}</Link>
                          ) : (
                            <Link to={routes.orders}>{t("all_orders")}</Link>
                          ),
                        key: "orders_or_cashback", // Unique key for this breadcrumb
                      },
                      {
                        title: `${orderDetail?.order_details?.order_no}`,
                        key: "order_detail", // Unique key for this breadcrumb
                      },
                    ]}
                  />
                </div>
              </div>

              <div>
                <div className="flex flex-row items-start justify-between">
                  <div className="flex items-center text-base font-medium mt-2 ">
                    <span>{orderDetail?.order_details?.partner_name}</span>
                    <span className="w-2 h-2 bg-[#1b4597] rounded mx-2"></span>
                    <span>
                      {orderDetail ? (
                        <>
                          {t("Placed on")}{" "}
                          {orderDetail?.order_details?.order_date
                            .substring(0, 10)
                            .replace(/-/g, "/")}{" "}
                          {orderDetail?.order_details?.order_date.substring(
                            11,
                            13
                          ) == 12
                            ? orderDetail?.order_details?.order_date.substring(
                              11,
                              16
                            ) + " PM"
                            : orderDetail?.order_details?.order_date.substring(
                              11,
                              13
                            ) > 12
                              ? orderDetail?.order_details?.order_date.substring(
                                11,
                                13
                              ) -
                              12 +
                              orderDetail?.order_details?.order_date.substring(
                                13,
                                16
                              ) +
                              " PM"
                              : orderDetail?.order_details?.order_date.substring(
                                11,
                                16
                              ) + " AM"}
                        </>
                      ) : (
                        <span> </span>
                      )}
                    </span>
                  </div>
                  <div className="flex float-right ">
                    {/* {(orderDetail?.order_details?.order_status ===
                      "Order Pending" ||
                      (orderDetail?.order_details?.order_status ===
                        "In Processing" &&
                        is_lahloob) ||
                        (orderDetail?.order_details?.order_status ===
                        "Out For Delivery") ||
                      (orderDetail?.order_details?.order_status ===
                        "Out For Delivery" &&
                        !is_lahloob)) && (
                      <button
                        type="submit"
                        className="w-[160px] h-[45px] me-2 bg-white text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
                        onClick={handleOpenCancelOrder}
                      >
                        {t("cancel")}
                      </button>
                    )} */}
                    {(orderDetail?.order_details?.order_status ===
                      "Order Pending" ||
                      (orderDetail?.order_details?.order_status ===
                        "In Processing" &&
                        is_lahloob)) && (
                        <button
                          type="submit"
                          className="w-[160px] h-[45px] me-2 bg-white text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
                          // onClick={handleOpenCancelOrder}
                          onClick={() => {
                            if (!checkPermission("/orders")) {
                              // permission denied, toast is shown inside checkPermission
                              return;
                            }

                            setloading(true);

                            handleOpenCancelOrder();
                          }}
                        >
                          {t("cancel")}
                        </button>
                      )}

                    {orderDetail?.order_details?.order_status ===
                      "Order Cancelled" &&
                      orderDetail?.order_details?.order_items_returned ===
                      false && (
                        <button
                          type="submit"
                          className="w-[190px] h-[45px] me-2 bg-primaryBlue text-white font-semibold rounded-lg inline border border-primaryBlue"
                          // onClick={handleReturnCancelOrder}
                          onClick={() => {
                            if (!checkPermission("/orders")) {
                              // permission denied, toast is shown inside checkPermission
                              return;
                            }

                            setloading(true);

                            handleReturnCancelOrder();
                          }}
                        >
                          {t("Return Cancel Order")}
                        </button>
                      )}

                    {data?.order_details?.order_status === "Order Pending" ||
                      (data?.order_details?.order_status === "In Processing" &&
                        !data?.order_details?.order_accepted) ? (
                      <button
                        type="submit"
                        className={`w-[160px] h-[45px] mx-5 ${acceptbutton
                          ? "bg-primaryBluedisabled"
                          : "bg-primaryBlue"
                          } text-white rounded-lg font-semibold  `}
                        // onClick={() => {
                        //   setloading(true);

                        //   let orderId = orderDetail?.order_details?.order_id;
                        //   // console.log("ORDER ID", orderId);

                        //   acceptOrder(user_id, orderId, is_lahloob).then(
                        //     (response) => {
                        //       calldata(searchid);
                        //       setloading(false);
                        //     }
                        //   );
                        // }}
                        onClick={() => {
                          if (!checkPermission("/orders")) {
                            // permission denied, toast is shown inside checkPermission
                            return;
                          }

                          setloading(true);

                          let orderId = orderDetail?.order_details?.order_id;

                          acceptOrder(user_id, orderId, is_lahloob).then((response) => {
                            calldata(searchid);
                            setloading(false);
                          });
                        }}
                        disabled={acceptbutton}
                      >
                        {t("accept")}
                      </button>
                    ) : data?.order_details?.order_status === "In Processing" &&
                      data?.order_details?.order_accepted ? (
                      <button
                        type="submit"
                        className={`w-[150px] h-[45px] me-3 bg-primaryBlue text-white rounded-lg font-semibold  ${!canProcessOrder
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                          }`}
                        // onClick={() => {
                        //   setloading(true);
                        //   let orderId = orderDetail?.order_details?.order_id;
                        //   processOrderActions(orderId);
                        // }}
                        onClick={() => {
                          if (!checkPermission("/orders")) {
                            // permission denied, toast is shown inside checkPermission
                            return;
                          }
                          setloading(true);
                          let orderId = orderDetail?.order_details?.order_id;
                          processOrderActions(orderId);
                        }}
                        disabled={!canProcessOrder}
                      >
                        {t("process_order")}
                      </button>
                    ) : null}

                    {/* {data?.order_details?.order_status ===
        "Ready For Delivery" &&
        !is_lahloob && (
          <button
            type="submit"
            className="w-[180px] h-[45px] mr-4 bg-primaryBlue text-white rounded-lg font-semibold  "
            onClick={handleAssignForDelivery}
          >
            {t("assign_delivery")}
          </button>
        )} */}

                    {data?.order_details?.delivery_boy_id &&
                      data?.order_details?.order_handed_over === false &&
                      data?.order_details?.order_status ===
                      "Ready For Delivery" && (
                        <button
                          type="submit"
                          className="w-[180px] h-[45px] mr-4 bg-primaryBlue text-white rounded-lg font-semibold  "
                          // onClick={() =>
                          //   handleHandover(data?.order_details?.order_id)
                          // }
                          onClick={() => {
                            if (!checkPermission("/orders")) {
                              // permission denied, toast is shown inside checkPermission
                              return;
                            }
                            handleHandover(data?.order_details?.order_id)
                          }}
                        >
                          {t("Order Handover")}
                        </button>
                      )}
                  </div>
                </div>
              </div>

              {/* Order List  */}
              <div className="flex w-full item-center justify-between ">
                <div className=" md:w-full   rounded-xl bg-[#FFFFFF] text-black float-left mb-4 me-4 mt-3">
                  <p className="flex justify-between items-center px-4 py-[1.37vh] border-b">
                    <span className="font-semibold text-base">
                      {t("item_list")}
                    </span>
                    {(orderDetail?.order_details?.order_status ===
                      "Order Delivered" ||
                      orderDetail?.order_details?.order_status ===
                      "Ready For Delivery") && (
                        <button
                          type="submit"
                          className=" px-4 h-10 bg-[#7EC242] text-white text-sm rounded-lg font-semibold"
                          // onClick={handlePrintOrderList}
                          onClick={() => {
                            if (checkPermission("/orders")) {
                              handlePrintOrderList()
                            }
                          }}
                        >
                          {orderDetail?.order_details?.order_status ===
                            "Ready For Delivery"
                            ? t("print_packing_slip")
                            : t("invoice")}
                        </button>
                      )}
                  </p>
                  <div className="overflow-auto h-auto">
                    {[
                      ...((orderDetail?.new_items?.length > 0
                        ? data?.new_items
                        : data?.existing_items) || []),
                      ...(replaceRelatedItems?.replacingItems || []),
                    ]?.map((val, i) => {
                      const isReplaced =
                        replaceRelatedItems?.replacedItems?.some(
                          (replaced) => replaced?.product_id === val?.product_id
                        );
                      const isReplacing =
                        replaceRelatedItems?.replacingItems?.some(
                          (replaced) => replaced?.product_id === val?.product_id
                        );

                      const finalVal = {
                        ...val,
                        ...(isReplaced ? { isReplaced: true } : {}),
                      };
                      const allItems = [
                        ...draftquantites,
                        ...(replaceRelatedItems?.replacingItems || []),
                      ];
                      return (
                        // {data?.existing_items?.map((val, i) => (
                        <div
                          className={`border-b overflow-hidden mt-2 ${val.product_uom_qty != null ? "bg-[#FCC71D1A]" : ""
                            } ${isReplaced ? "opacity-40 pointer-events-none" : ""
                            }`}
                          key={i}
                        >
                          {/* {console.log("value", val)} */}
                          <div className="flex my-3 mb-2 mx-6  justify-between">
                            <div className="flex items-center">
                              <span className="flex flex-col">
                                {" "}
                                <Image
                                  src={val.image}
                                  width={50}
                                  height={50}
                                  alt="P.Image"
                                />
                                <span className="flex flex-row text-xs mt-2 ">
                                  <img
                                    src={weight_icon}
                                    height={16}
                                    width={16}
                                    alt="weight"
                                  // style={{
                                  //   minWidth: "17rem",
                                  //   maxWidth: "18rem",
                                  //   maxHeight: "13rem",
                                  //   minHeight: "12rem",
                                  // }}
                                  />
                                  <p className="mt-1">{val.product_uom}</p>
                                </span>
                              </span>
                              <span className="flex flex-col justify-center gap-1">
                                <span className="font-semibold  text-xs ms-3 me-3">
                                  {val?.product_name}
                                </span>

                                <span className="ms-3 text-xs font-normal">
                                  {/* {data?.order_details?.order_status ===
                              "Ready For Delivery"
                                ? 1
                                : 1}{" "} */}
                                  {val.product_barcode}
                                </span>
                                <span className="text-xs ms-3">
                                  {t("Order Qty")} {val.product_uom_qty}
                                </span>
                                {data?.order_details?.order_status !==
                                  "In Processing" && (
                                    <>
                                      <span className="text-xs ms-3">
                                        {t("Pick Qty")} {val?.pick_qty}
                                      </span>
                                    </>
                                  )}
                                {data?.order_details?.order_status ===
                                  "In Processing" && (
                                    <>
                                      <span className="text-xs ms-3 font-semibold">
                                        EGP  {val.price_total ? new Intl.NumberFormat('en-EG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val.price_total) : '0.00'}
                                      </span>
                                    </>
                                  )}
                              </span>
                            </div>

                            <span className="ms-auto flex flex-col items-center justify-center">
                              {data?.order_details?.order_status ===
                                "In Processing" &&
                                data?.order_details?.order_accepted === true ? (
                                <>
                                  <div className="flex flex-row items-center justify-between">
                                    <div className="flex flex-row items-center rounded-lg bg-[#61d0f2] justify-between  border">
                                      <button
                                        className="font-extrabold text-lg text-center p-1.5 px-2"
                                        onClick={() => {
                                          const currentQuantity =
                                            draftquantites.find(
                                              (item) =>
                                                item?.product_id ===
                                                val?.product_id
                                            )?.value || 0;

                                          // Call handleQuantityChange with currentQuantity - 1
                                          handleQuantityChange(
                                            currentQuantity - 1,
                                            i,
                                            val.order_id,
                                            val.id,
                                            val.product_id
                                          );
                                        }}
                                        disabled={
                                          (draftquantites.find(
                                            (item) =>
                                              item?.product_id ===
                                              val?.product_id
                                          )?.value || 0) === 0
                                        }
                                      >
                                        -
                                      </button>
                                      <input
                                        type="number"
                                        className="w-16 h-10 border-x float-right text-center"
                                        placeholder="Qty"
                                        style={{
                                          outline: "none", // Remove outline on focus
                                        }}
                                        min="0"
                                        max={
                                          val?.available_qty >
                                            val?.product_uom_qty
                                            ? val?.product_uom_qty
                                            : val?.available_qty
                                        }
                                        onChange={(e) => {
                                          handleQuantityChange(
                                            e,
                                            i,
                                            val?.available_qty,
                                            val.order_id,
                                            val.id,
                                            val.product_id,
                                            val.sell_price
                                          );
                                        }}
                                        value={
                                          draftquantites.find(
                                            (item) =>
                                              item?.product_id ===
                                              val?.product_id
                                          )?.value !== undefined
                                            ? draftquantites.find(
                                              (item) =>
                                                item?.product_id ===
                                                val?.product_id
                                            )?.value
                                            : val?.product_uom_qty // Set initial value to product_uom_qty
                                        }
                                        readOnly
                                      />

                                      <button
                                        className="font-extrabold text-lg text-center p-1.5 px-2"
                                        onClick={() => {
                                          const currentQuantity =
                                            draftquantites.find(
                                              (item) =>
                                                item?.product_id ===
                                                val?.product_id
                                            )?.value || 0;
                                          handleQuantityChange(
                                            currentQuantity + 1,
                                            i,
                                            val.order_id,
                                            val.id,
                                            val.product_id
                                          );
                                        }}
                                        disabled={
                                          (draftquantites.find(
                                            (item) =>
                                              item?.product_id ===
                                              val?.product_id
                                          )?.value || 0) >=
                                          val?.product_uom_qty && !isReplacing
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                    {orderDetail?.order_details
                                      ?.order_status === "In Processing" && (
                                        <button
                                          className="rounded-md font-semibold text-gray-100 ms-s"
                                          onClick={() => {
                                            handleQuantityChange(
                                              0,
                                              "btn",
                                              val.order_id,
                                              val.id,
                                              val.product_id
                                            );
                                          }}
                                        >
                                          <img
                                            className="mx-1"
                                            src={deleteicon}
                                            alt="deleteicon"
                                          />
                                        </button>
                                      )}
                                  </div>
                                  {orderDetail?.order_details?.payment_mode ===
                                    "COD" && (
                                      <>
                                        {isReplacing ? (
                                          <div
                                            onClick={() =>
                                              DeleteReplacingItem(val)
                                            }
                                            className="bg-[#7EC242] py-1 px-3 cursor-pointer mt-2 self-end rounded-md mx-8"
                                          >
                                            <span className="text-xs font-semibold text-white">
                                              {t("Remove")}
                                            </span>
                                          </div>
                                        ) : (
                                          <>
                                            {!isReplaced && (
                                              <div
                                                onClick={() => {
                                                  // openReplaceWindow(val);
                                                  setItemToReplace(val);
                                                  setOpenReplaceItemModal(true);
                                                }}
                                                className="bg-[#7EC242] py-1 px-3 cursor-pointer mt-2 self-end rounded-md mx-8"
                                              >
                                                <span className="text-xs font-semibold text-white">
                                                  {t("Replace")}
                                                </span>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                </>
                              ) : data?.order_details?.order_status !=
                                "In Processing" ? (
                                <div className="flex flex-col mt-0 items-center">
                                  <span className="text-xs ms-3 font-semibold">
                                    EGP {val.price_total}
                                  </span>
                                  {/* <span className="font-semibold text-xs">
                                  {t("Pick Qty")}
                                </span>
                                <span className="font-normal mt-1 text-xs">
                                  {val?.pick_qty}
                                </span> */}
                                </div>
                              ) : (
                                <></>
                              )}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {/* (data?.order_stage?.id==4 || data?.order_stage?.id==5 )  &&  */}
                  {
                    <PaymentInfo
                      billDetails={billDetails}
                      totalPrice={data?.order_total_amt}
                      payment={data?.payment_mode}
                      delivery_charge={data?.delivery_charge}
                    />
                  }
                </div>
                {/* {data?.order_stage?.name != "In Processing" ? ( */}
                <OrdercustomerDetails
                  OrderData={orderDetail}
                // deliverydate={orderDetail}
                // address_details={orderDetail}
                // order_stage={orderDetail}
                // Deliveryboy={orderDetail}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <DeliveryBoyDetails
        isOpen={isModalVisible} // Pass the state to manage modal visibility
        onClose={() => setIsModalVisible(false)}
        order_id={orderDetail.order_details?.order_id}
        Popup={() => {
          setpopup(true);
          setPopupMessage("Delivery Boy Assigned Successfully");
        }}
      />
      {/* Render CancelOrder component when isCancelOrderOpen is true */}

      {isReturnCancelOrderOpen && (
        <ReturnCancelOrder
          isOpen={isReturnCancelOrderOpen}
          onClose={() => setReturnCancelOrderOpen(false)}
          order_id={orderDetail.order_details?.order_id}
          data={orderDetail}
          popup={() => setcancelledpopup(true)}
        />
      )}

      {isCancelOrderOpen && (
        <CancelOrder
          isOpen={isCancelOrderOpen}
          onClose={() => setCancelOrderOpen(false)}
          order_id={orderDetail.order_details?.order_id}
          popup={() => setcancelledpopup(true)}
        />
      )}
      {cancelledpopup && (
        <Cancelledpopup
          onClose={() => {
            setcancelledpopup(false);
            calldata(searchid);
          }}
        />
      )}
      {deliveredpopup && (
        <Orderdeliveredpopup
          orderno={data?.order_number}
          onClose={() => {
            setdeliveredpopup(false);
            calldata(searchid);
          }}
        />
      )}
      {popup && (
        <AssignDeliveryBoypopup
          message={t(popupMessage)}
          onClose={() => {
            setpopup(false);
            calldata(searchid);
          }}
        />
      )}
      {SuccessPopup && (
        <CompleteSuccess
          message={t(popupMessage)}
          onClose={() => {
            setSuccessPopup(false);
            calldata(searchid);
          }}
        />
      )}

      {replaceItemModal && (
        <ReplaceItemModal
          isOpen={replaceItemModal}
          onClose={() => {
            setOpenReplaceItemModal(false);
            setItemToReplace({});
          }}
          product={itemToReplace}
          replaceItem={(val1, val2) => HandleReplaceItem(val1, val2)}
          allProducts={[
            ...(orderDetail?.new_items?.length > 0
              ? data?.new_items || []
              : data?.existing_items || []),
            ...(replaceRelatedItems?.replacingItems || []),
          ]}
        />
      )}
    </>
  );
};

export default Orderlist;
